import { toast } from 'react-toastify';
import React, { useState } from 'react';
// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import { BeatLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { Button, InputAdornment, TextField } from '@material-ui/core';

import Prompt from '../../Shared/Prompt/Prompt';
import PromptWrapper from '../../Shared/Prompt/Wrapper';
import PromptActions from '../../Shared/Prompt/Actions';

import { decodeHTMLEntities } from '../../../Functions/utils';

import { changePw } from '../../../Functions/user';
import { useAppContext } from '../../../Context/App/Provider';

import { toastTimerValue } from '../../../Shared/utils';
import '../../SweetAlert.css'


export default function ChangePassword({setResetPw}) {
  const { t } = useTranslation();
  const [{user}] = useAppContext();

  const [loading, setLoading] = useState(false);
  const [passwords, setPasswords] = useState({oldPw: '', newPw: '', repeat: ''});


  const handleChangePassword = async (e, passwords) => {
    e.preventDefault();

    if (passwords.newPw && passwords.newPw !== passwords.repeat)
      return toast(t('settings.errors.password.different'), {type: 'error'});

    // ***** if (window.confirm(t('settings.password.reset'))) {

    //   Swal({
    //   title: t('global.dialog_title'),
    //   text: t('settings.password.reset'),
    //   // icon: "warning",
    //   buttons: {
    //     confirm: {
    //       text: t("global.yes"),
    //       value: true,
    //       visible: true,
    //       className: "btnPrimary",
    //       closeModal: true
    //     },
    //     cancel: {
    //       text: t("global.no"),
    //       value: false,
    //       visible: true,
    //       className: "btnSecondary",
    //       closeModal: true,
    //     }
    //   },
    //   closeOnClickOutside: false
    // }).then(async (value) => {

    //   if (value) {
    //     setLoading(true);
    //     const res = await changePw(passwords);
    //     setLoading(false);

    //     if (!res.success)
    //       return toast(t('settings.errors.password.' + res), { type: 'error' });

    //     toast(t('settings.password.success'), { type: 'success' });
    //     setResetPw(false);
    //   }
    // });

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('settings.password.reset'),
      showCancelButton: true,
      confirmButtonText: t("global.yes"),
      cancelButtonText: t("global.no"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then(async (value) => {
      // console.log("86 - value=", value);

      if (value && value.isConfirmed) {
      setLoading(true);
      const res = await changePw(passwords);
      setLoading(false);

        if (!res.success) {
          return toast(decodeHTMLEntities(t('settings.errors.password.' + res)), { type: 'error' });

          // return Swal.fire({
          //   toast: true,
          //   icon: 'error',
          //   title: t('settings.errors.password.' + res),
          //   animation: true,
          //   position: 'top-right',
          //   showConfirmButton: false,
          //   timer: toastTimerValue,
          //   timerProgressBar: true,
          //   iconColor: 'white',
          //   customClass: {
          //     popup: 'colored-toast',
          //   },
          //   didOpen: (toast) => {
          //     toast.addEventListener('mouseenter', Swal.stopTimer)
          //     toast.addEventListener('mouseleave', Swal.resumeTimer)
          //     toast.addEventListener('click', Swal.close)
          //   }
          // });
        }

        toast(decodeHTMLEntities(t('settings.password.success')), { type: 'success' });

        // Swal.fire({
        //   toast: true,
        //   icon: 'success',
        //   title: t('settings.password.success'),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      setResetPw(false);
    }
    });
  };


  return (
    <Prompt animated>
      <form className="prompt__container animated" style={{ height: '60%' }} onSubmit={e => handleChangePassword(e, passwords)}>
        <PromptWrapper className="prompt__wrapper">
          <div className="prompt__title">
            <h1>{t('settings.password.label')}</h1>
          </div>

          <div className="prompt__content">
            <TextField variant="outlined" style={{display: 'none'}} name="username" value={user.email}/>

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">lock_open</span>
                </InputAdornment>
              }}
              type="password"
              variant="outlined"
              autoComplete="off"
              value={passwords.oldPw}
              label={t('reset.field0')}
              onChange={e => setPasswords({...passwords, oldPw: e.target.value})}
            />

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">lock</span>
                </InputAdornment>
              }}
              type="password"
              variant="outlined"
              value={passwords.newPw}
              label={t('reset.field1')}
              autoComplete="new-password"
              onChange={e => setPasswords({...passwords, newPw: e.target.value})}
            />

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">check</span>
                </InputAdornment>
              }}
              type="password"
              variant="outlined"
              value={passwords.repeat}
              label={t('reset.field2')}
              autoComplete="new-password"
              onChange={e => setPasswords({...passwords, repeat: e.target.value})}
            />
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setResetPw(false)}>
            {t('global.cancel')}
          </Button>

          <Button
            className="btnPrimary" type="submit"
            disabled={!passwords.oldPw || !passwords.newPw || !passwords.repeat || loading}
          >
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('global.confirm')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
